module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.fe1545ef.ttf";